// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fe-a";
export var fulfillmentFormRail = "_fe-9";
export var headerTitleRow = "_fe-c";
export var orderDetailsWrapper = "_fe-7";
export var orderLinkTrigger = "_fe-2";
export var paymentInformationGrid = "_fe-h";
export var paymentSummaryColumn = "_fe-i";
export var shipmentContainer = "_fe-b";
export var shipmentDetailsMainPane = "_fe-8";
export var shipmentNavigationCard = "_fe-5";
export var shipmentNavigationRail = "_fe-3";
export var shipmentNavigationRailHeader = "_fe-4";
export var shipmentSummaryFact = "_fe-e";
export var shipmentSummaryGrid = "_fe-d";
export var shipmentSummaryMetadataRow = "_fe-f";
export var shipmentSummaryTags = "_fe-g";
export var shipmentWorkspace = "_fe-0";
export var shipmentWorkspaceContent = "_fe-6";
export var shipmentWorkspaceHeader = "_fe-1";